import React from 'react';
import {
  Container,
  Content,
  Footer,
  ContainerModal,
  Text,
} from './styles/StyledModalSketchReport';
import { Icon, Typography, Button } from '@wisecare-tech/design-system-web';
import { MessageOptions } from '~/domain/interfaces/redux/message';
import { iMessage } from '~/domain/interfaces/models';

interface propsModalSketchReport {
  message: iMessage;
}

const ModalSketchReport: React.FC<propsModalSketchReport> = ({ message }) => {
  const { active, actionCancel, actionOk, data } = message;

  const msgName = MessageOptions.sketchReport;

  return (
    <>
      {msgName === active && (
        <ContainerModal>
          <Container>
            <Content>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#E6F0FB',
                  borderRadius: '9999px',
                  aspectRatio: '1',
                  width: '40px',
                }}
              >
                <Icon name="info" color="blue-7" size="h5" />
              </div>
              <Text>
                <Typography
                  variant="t1_18semibold"
                  style={{ fontFamily: 'Roboto' }}
                >
                  Salvar solicitação como rascunho
                </Typography>
                <Typography
                  variant="b1_16regular"
                  style={{
                    color: '#656A6E',
                    fontFamily: 'Roboto',
                    fontSize: '16px',
                  }}
                >
                  Ao salvar como rascunho, as informações adicionadas até agora
                  serão salvas para você continuar depois. Apenas você e o
                  administrador poderão editar.
                </Typography>
              </Text>
            </Content>
            <Footer>
              <Button variant="secondary" onClick={actionCancel}>
                Voltar
              </Button>
              <Button variant="primary" onClick={actionOk}>
                Salvar como rascunho
              </Button>
            </Footer>
          </Container>
        </ContainerModal>
      )}
    </>
  );
};

export default ModalSketchReport;
